<div class="pop-up">
    <h1 mat-dialog-title style="text-align: center; color:blue;">NAVEGAR POR EL NODO</h1>
    <div mat-dialog-content>
        <div class="content-tree">
            <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">

                <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
                    <ng-container *ngIf="node.tipo=='Object'">
                        <b>{{node.nombre_es}}</b>
                    </ng-container>
                    <ng-container *ngIf="node.tipo!='Object'">
                        <b>{{node.nombre_es}}</b>:{{node.value}}
                    </ng-container>
                </mat-tree-node>

                <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                    <div class="mat-tree-node">
                        <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.nombre_es">
                            <mat-icon class="mat-icon-rtl-mirror">
                                {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                            </mat-icon>
                        </button>
                        <ng-container *ngIf="node.tipo=='Object'">
                            <b>{{node.nombre_es}}</b>
                        </ng-container>
                    </div>

                    <div [class.example-tree-invisible]="!treeControl.isExpanded(node)" role="group">
                        <ng-container matTreeNodeOutlet></ng-container>
                    </div>
                </mat-nested-tree-node>
            </mat-tree>
        </div>        
    </div>
    <div mat-dialog-actions>
    <button color="primary" class="right" mat-button [mat-dialog-close]="null"> 
        {{'TABLES.CANCEL' | translate}}
    </button></div>
</div>